// extracted by mini-css-extract-plugin
export default {"category-id-section":"NftCategoryIdSection_category-id-section__BTgBQ"};